import React from "react";
import cx from "classnames";
import { InputLabel } from "../inputLabel";
import { InputWrapper } from "../inputWrapper";
import { RadioInputWrapper } from "./radioInputWrapper";
import { ValidationMessage } from "../validationMessage";

export const RadioGroup = (props) => {
  const {
    title,
    onChange,
    onBlur,
    options,
    value,
    name,
    toolTipText,
    className,
    combined,
    errorMessage
  } = props;

  return (
    <InputWrapper className={className} name={name}>
      <InputLabel name={name} toolTipText={toolTipText} title={title} />
      <div className="radio-group" role="radiogroup" aria-labelledby={`${name}Label`}>
        {options.map((option, index) => {
          const checked = value === option.value;

          return (
            <RadioInputWrapper
              key={`radio-${index}`}
              className={cx({"has-error": errorMessage})}
              combined={combined}
              checked={checked}>
                {(ref) => (
                  <>
                    <input
                      type="radio"
                      aria-label={option.label}
                      name={name}
                      className={className}
                      value={option.value}
                      checked={checked}
                      onChange={onChange}
                      onBlur={onBlur}
                      ref={ref}
                      hidden
                    />
                    <label>{option.label}</label>
                  </>
                )}
            </RadioInputWrapper>
          );
        })}
      </div>
      <ValidationMessage errorMessage={errorMessage} />
    </InputWrapper>
  );
}